import { PageHeader } from '@/components/layout/AppShell'

/** A partner or group user with no brands assigned yet. */
export function NoAccess() {
  return (
    <>
      <PageHeader title="No brands assigned" />
      <p className="max-w-lg text-sm text-muted-foreground">
        Your account isn't linked to any brand yet. Ask your Atarim contact to assign you to your brand or hosting group, then sign
        in again.
      </p>
    </>
  )
}
